export default __webpack_public_path__ + "static/media/high-school-2.92ec99ab.jpg";